export enum CompanyServiceType {
    SHIPPER = "Shipper",
    FLEET_OWNER = "Fleet Owner",
    TRANSPORT_CONTRACTOR = "Transport Contractor",
    AGENT_BROKER = "Agent/Broker",
    DEPRECATED_SERVICE_TYPE = "Transport Contractor, Agent/Broker"
}

export type CompanyServiceTypeMapType = {
    [key in CompanyServiceType]: string;
};

export const CompanyServiceTypeMap: CompanyServiceTypeMapType = {
    [CompanyServiceType.SHIPPER]: "Shipper",
    [CompanyServiceType.FLEET_OWNER]: "Truck Owner / Driver",
    [CompanyServiceType.TRANSPORT_CONTRACTOR]: "Transporter",
    [CompanyServiceType.AGENT_BROKER]: "Transporter",
    [CompanyServiceType.DEPRECATED_SERVICE_TYPE]: "Transport Contractor, Agent/Broker"
};

export enum ServiceTypeId {
    SHIPPER = 1,
    TRUCKER = 2,
    TRANSPORTER = 3
}

export const ServiceTypeIdName = {
    [ServiceTypeId.SHIPPER]: "Shipper",
    [ServiceTypeId.TRUCKER]: "Trucker",
    [ServiceTypeId.TRANSPORTER]: "Transporter"
};

export const CommonServiceType: string[] = [
    CompanyServiceType.TRANSPORT_CONTRACTOR,
    CompanyServiceType.SHIPPER,
    CompanyServiceType.FLEET_OWNER
];

export function getServiceTypeId(serviceType?: string): ServiceTypeId | undefined {
    switch (serviceType) {
        case CompanyServiceType.SHIPPER:
            return ServiceTypeId.SHIPPER;
        case CompanyServiceType.FLEET_OWNER:
            return ServiceTypeId.TRUCKER;
        case CompanyServiceType.TRANSPORT_CONTRACTOR:
        case CompanyServiceType.AGENT_BROKER:
        case CompanyServiceType.DEPRECATED_SERVICE_TYPE:
            return ServiceTypeId.TRANSPORTER;
        default:
            return undefined;
    }
}
